// extracted by mini-css-extract-plugin
module.exports = {"autocomplete":"_1WfkwPh","selected":"_3MfUeg0"};